<label [attr.id]="id"
  [attr.for]="for"
  [attr.aria-disabled]="disabled"
  [ngClass]="{'disabled': disabled}"
  [attr.data-testid]="'vi-label-' + (for || id)">
  {{ value }}
  <span *ngIf="required"
    class="asterisk"
    [attr.data-testid]="'vi-label-required-' + (for || id)">*</span>
</label>